// The delivery modal info is administered through Umbraco
import React, { useEffect, useMemo, useState } from "react";
import { DA_Modal } from "@danishagro/shared/src/components/molecules/Modal/Modal.component";
import { DA_DeliveryInfoModalData } from "@interfaces/deliveryInfoModalData.interface";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import { DA_Title } from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { DA_InlineLink } from "@danishagro/shared/src/components/atoms/InlineLink/InlineLink.component";
import { getDeliveryInfoModalContent } from "@helpers/getDeliveryInfoModalContent.helper";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { DA_Table } from "@danishagro/shared/src/components/atoms/Table/Table.component";
import { TableRowSimple } from "@danishagro/shared/src/components/atoms/Table/TableProps";
import S from "./DeliveryInfoModal.module.scss";

export interface DeliveryInfoModalContentProps {
    specialFreightOverlayText?: string;
}

export const DA_DeliveryInfoModalContent = (props: DeliveryInfoModalContentProps) => {
    const [modalContent, setModalContent] = useState<DA_DeliveryInfoModalData>();
    const { getDictionaryString } = useTranslations();

    const deliveryModalTitle = props.specialFreightOverlayText
        ? getDictionaryString("deliveryInfo.infoOverwrite")
        : modalContent?.modal.title;

    useEffect(() => {
        getDeliveryInfoModalContent().then((response) => {
            setModalContent(response);
        });
    }, []);

    const columns = [
        { title: getDictionaryString("deliveryInfo.shippingLimits") },
        { title: getDictionaryString("general.price"), alignRight: true },
    ];

    const data: TableRowSimple[] = useMemo(() => {
        return (
            modalContent?.modal?.table?.items?.map((item) => {
                return [
                    { content: item.freightLimit, value: item.freightLimit },
                    { content: item.freightPrice, value: item.freightPrice, alignRight: true },
                ];
            }) || []
        );
    }, [modalContent?.modal?.table?.items]);

    return (
        <DA_Modal title={deliveryModalTitle} closeButtonBottom>
            {/* Description */}
            <DA_Text
                html={
                    props.specialFreightOverlayText
                        ? props.specialFreightOverlayText
                        : modalContent?.modal.description
                }
            />

            {/* Table */}
            {modalContent?.modal?.table && (
                <div className={S.tableWrapper}>
                    <DA_Table columns={columns} data={data} />
                </div>
            )}

            {/* Bottom description */}
            {modalContent?.modal.bottomDescription && (
                <DA_Text html={modalContent?.modal.bottomDescription} />
            )}

            {/* Links */}
            <div className={S.linkboxes}>
                {modalContent?.modal.linkBoxes.map((item, index) => (
                    <div key={index} className={S.linkbox}>
                        {item.links?.map((link, index) => (
                            <div key={index}>
                                {link.title && <DA_Title h3>{link.title}</DA_Title>}
                                <DA_InlineLink
                                    target="_blank"
                                    className={S.linkTag}
                                    title={link.linkText}
                                    href={link.link}
                                />
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </DA_Modal>
    );
};
